<template>
  <div class="main-wrapper" :class="{ 'portrait': orientation === 'portrait' }">

    <Loading v-if="!imagesLoaded" :percentLoaded="percentLoaded"/>

    <Orientation v-if="orientation === 'portrait'"/>

    <transition>
      <Colofon v-show="showColofon" :colofon="colofon" @close="toggleColofon()"/>
    </transition>

    <div class="scroll-wrapper" ref="scrollWrapper">

      <div class="scroller" ref="scroller" :class=" { 'cursor-pointer': currentTileIndex === colofonButton.index } ">

      </div>

    </div>

    <div class="canvas-wrapper" :class="{ 'images-loaded': imagesLoaded }" ref="canvasWrapper" />

    <div class="images-wrapper">
      <slot v-for="(imageUrl, index) in imageUrls">
        <div :key="index" :style="{backgroundImage:'url('+imageUrl+')'}">
        </div>
      </slot>
    </div>


  </div>

</template>

<script>
/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["sprite", "container", "button"] }] */
/* eslint max-len: ["error", { "code": 150, "ignoreTrailingComments": true, "ignoreTemplateLiterals": true }] */

import axios from 'axios'
import detectIt from 'detect-it'
import * as PIXI from 'pixi.js'
import Loading from '@/components/Loading'
import Colofon from '@/components/Colofon'
import Orientation from '@/components/Orientation'

import Stats from 'stats-js'

export default {
  name: 'Main',
  components: {
    Loading,
    Colofon,
    Orientation,
  },
  data() {
    return {
      colofon: undefined,
      images: [],
      imageUrls: [],
      app: new PIXI.Application({
        width: document.documentElement.clientWidth,
        height: document.documentElement.clientHeight, // default: 600
        antialias: false, // default: false
        transparent: true, // default: false
        resolution: (window.devicePixelRatio > 2) ? 2 : window.devicePixelRatio, // default: 1
      }),
      loader: PIXI.loader,
      resources: PIXI.loader.resources,
      Sprite: PIXI.Sprite,
      sprites: [],
      buttons: [],
      colorSprites: [],
      containers: [],
      leftContainer: new PIXI.Container(),
      rightContainer: new PIXI.Container(),
      mainContainer: new PIXI.Container(),
      resizeTimer: undefined,
      pixelRatio: (window.devicePixelRatio > 2) ? 2 : window.devicePixelRatio,
      screenWidth: document.documentElement.clientWidth,
      screenHeight: document.documentElement.clientHeight,
      percentLoaded: 0,
      imagesLoaded: false,
      showColofon: false,
      colofonButton: {},
      colofonButtonBlink: false,
      colofonButtonBlinkInterval: undefined,
      currentTileIndex: 0,
      orientation: (window.innerWidth > window.innerHeight) ? 'landscape' : 'portrait',
      renderedFrames: 0,
      stats: new Stats(),
      userScrolled: false,
      autoScroll: false,
      startTimeout: undefined,
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  created() {
    window.addEventListener('resize', this.handleResize)

    axios.get('https://larissakirby.hfg-kralsruhe.de/projects')
      .then((response) => {
        this.colofon = response.data.colofon
        this.images = response.data.files
        this.imageUrls = response.data.files.map((el) => {
          const screensize = (this.orientation === 'portrait') ? this.screenWidth : this.screenHeight
          if ((screensize * window.devicePixelRatio) > 2200) {
            return el.xl
          } else if ((this.screenHeight * window.devicePixelRatio) > 1800) {
            return el.l
          } else if ((this.screenHeight * window.devicePixelRatio) > 1400) {
            return el.m
          } else if ((this.screenHeight * window.devicePixelRatio) > 1000) {
            return el.s
          }
          return el.xs
        })
        this.$nextTick(() => {
          this.init()
        })
      })
      .catch((e) => {
        // eslint-disable-next-line no-console
        console.error(e)
      })
  },
  watch: {
    currentTileIndex(newIndex, oldIndex) {
      if (newIndex !== oldIndex) {
        if (newIndex === this.colofonButton.index) {
          clearInterval(this.colofonButtonBlinkInterval)
          this.colofonButton.sprite.tint = `0x${this.images[this.colofonButton.index].hoverColor}`
          this.colofonButton.colorSprite.tint = `0x${this.images[this.colofonButton.index].hoverColor}`
        } else if (oldIndex === this.colofonButton.index) {
          this.blink()
          this.colofonButton.sprite.tint = `0x${this.images[this.colofonButton.index].color}`
          this.colofonButton.colorSprite.tint = `0x${this.images[this.colofonButton.index].color}`
        }
      }
    },
  },

  mounted() {
    if (this.$route.name === 'Debug') {
      this.stats.setMode(0) // 0: fps, 1: ms
      this.stats.domElement.style.position = 'fixed'
      this.stats.domElement.style.zIndex = '9999999'
      this.stats.domElement.style.left = '0px'
      this.stats.domElement.style.top = '0px'

      document.body.appendChild(this.stats.domElement)
    }
  },

  methods: {

    setAutoScroll() {
      setTimeout(() => {
        this.autoScroll = true
      }, 4000)
    },

    blink() {
      this.colofonButtonBlinkInterval = setInterval(() => {
        if (this.colofonButtonBlink) {
          this.colofonButtonBlink = !this.colofonButtonBlink
          this.colofonButton.sprite.tint = `0x${this.images[this.colofonButton.index].color}`
          this.colofonButton.colorSprite.tint = `0x${this.images[this.colofonButton.index].color}`
        } else {
          this.colofonButtonBlink = !this.colofonButtonBlink
          this.colofonButton.sprite.tint = `0x${this.images[this.colofonButton.index].hoverColor}`
          this.colofonButton.colorSprite.tint = `0x${this.images[this.colofonButton.index].hoverColor}`
        }
      }, 700)
    },

    mouseClick(e) {
      if (this.showColofon) {
        this.showColofon = !this.showColofon
      } else {
        const left = (e.clientX <= (this.screenWidth / 2))
        const scroll = this.$refs.scrollWrapper.scrollTop
        let index = 0
        if (!left) {
          index = ((Math.floor((scroll + (this.screenHeight - e.clientY)) / this.screenHeight)) * 2) + 1
        } else {
          index = (Math.floor((scroll + (e.clientY)) / this.screenHeight)) * 2
        }
        if (this.images[index].isColofonButton === '1') {
          this.showColofon = true
        }
      }
    },

    mouseMove(e) {
      const left = (e.clientX <= (this.screenWidth / 2))
      const scroll = this.$refs.scrollWrapper.scrollTop
      if (!left) {
        this.currentTileIndex = ((Math.floor((scroll + (this.screenHeight - e.clientY)) / this.screenHeight)) * 2) + 1
      } else {
        this.currentTileIndex = (Math.floor((scroll + (e.clientY)) / this.screenHeight)) * 2
      }
    },

    toggleColofon() {
      this.showColofon = !this.showColofon
    },

    handleResize() {
      this.screenWidth = document.documentElement.clientWidth
      this.screenHeight = document.documentElement.clientHeight
      this.orientation = (this.screenWidth > this.screenHeight) ? 'landscape' : 'portrait'
      clearTimeout(this.resizeTimer)
      this.resizeTimer = setTimeout(() => {
        this.resize()
      }, 0)
    },

    resize() {
      this.$refs.scroller.style.height = `${(this.images.length / 2) * this.screenHeight}px`
      this.app.renderer.resize(this.screenWidth, this.screenHeight)
      this.containers.forEach((container, index) => {
        if (index % 2 === 0) {
          container.y = (index / 2) * this.screenHeight
        } else {
          container.y = (((index - 1) / 2) * this.screenHeight) * -1
        }
      })
      this.rightContainer.x = this.screenWidth / 2
      this.sprites.forEach((sprite, index) => {
        if (this.images[index].cover === '1') {
          this.setTextureSizeCover(sprite, this.screenWidth / 2, this.screenHeight)
        } else {
          this.setTextureSizeContain(sprite, this.screenWidth / 2, this.screenHeight)
        }
      })
      this.colorSprites.forEach((colorSprite) => {
        this.setTextureSizeStretch(colorSprite, this.screenWidth / 2, this.screenHeight)
      })
    },

    init() {
      this.$refs.scroller.style.height = `${(this.images.length / 2) * this.screenHeight}px`

      this.$refs.canvasWrapper.appendChild(this.app.view)

      this.app.renderer.view.style.width = `${this.screenWidth}px`
      this.app.renderer.view.style.height = `${this.screenHeight}px`

      this.app.renderer.view.style.position = 'absolute'
      this.app.renderer.view.style.display = 'block'
      this.app.renderer.autoResize = true
      this.app.renderer.resize(this.screenWidth, this.screenHeight)

      this.loader
        .add(this.imageUrls)
        .on('progress', this.loadProgressHandler)
        .load(this.setupDelay)
    },

    setupDelay() {
      setTimeout(() => {
        this.setup()
      }, 10)
    },

    setup() {
      // MAKE SPRITES FROM TEXTURES
      this.imageUrls.forEach((el) => {
        this.sprites.push(new this.Sprite(this.loader.resources[el].texture))
      })

      // PUT SPRITES IN CONTAINERS
      this.sprites.forEach((sprite, index) => {
        const container = new PIXI.Container()
        const colorSprite = new PIXI.Sprite(PIXI.Texture.WHITE)

        colorSprite.tint = `0x${this.images[index].color}` // Change with the color wanted
        this.setTextureSizeStretch(colorSprite, this.screenWidth / 2, this.screenHeight)
        this.colorSprites.push(colorSprite)

        container.addChild(colorSprite)

        sprite.customIndex = index

        if (this.images[index].cover === '1') {
          this.setTextureSizeCover(sprite, this.screenWidth / 2, this.screenHeight, container)
        } else {
          this.setTextureSizeContain(sprite, this.screenWidth / 2, this.screenHeight)
        }

        // TINT COLOFON BUTTON SPRITES
        if (this.images[index].isColofonButton === '1') {
          this.$set(this.colofonButton, 'sprite', sprite)
          this.$set(this.colofonButton, 'colorSprite', colorSprite)
          this.$set(this.colofonButton, 'index', index)
          sprite.tint = `0x${this.images[index].color}` // Change with the color wanted
        }

        container.addChild(sprite)

        this.containers.push(container)
      })

      // BUILD MAIN CONTAINERS
      this.containers.forEach((container, index) => {
        if (index % 2 === 0) {
          container.y = this.leftContainer.children.length * this.screenHeight
          this.leftContainer.addChild(container)
        } else {
          container.y = (this.rightContainer.children.length * this.screenHeight) * -1
          this.rightContainer.addChild(container)
        }
      })

      // MOVE RIGHT CONTAINER
      this.rightContainer.x = this.screenWidth / 2

      // ADD TO MAIN CONTAINER
      this.mainContainer.addChild(this.leftContainer)
      this.mainContainer.addChild(this.rightContainer)

      // ADD TO STAGE
      this.app.stage.addChild(this.mainContainer)

      // INIT GAMELOOP
      this.app.ticker.add(delta => this.gameLoop(delta))

      // this.addButtons()

      this.imagesLoaded = true

      if (detectIt.deviceType === 'mouseOnly') {
        window.addEventListener('mousemove', this.mouseMove, false)
      }

      this.$refs.scrollWrapper.addEventListener('click', this.mouseClick)

      this.blink()
    },

    loadProgressHandler(loader) {
      this.percentLoaded = loader.progress
    },

    setTextureSizeCover(sprite, width, height, container) {
      let mask = sprite.mask
      if (!sprite.mask) {
        mask = new PIXI.Graphics(0, 0, this.screenWidth / 2, this.screenHeight)
        mask.drawRect(0, 0, this.screenWidth / 2, this.screenHeight)
        container.addChild(mask)
        sprite.mask = mask
      } else {
        this.setTextureSizeStretch(mask, this.screenWidth / 2, this.screenHeight)
      }

      const spriteWidth = sprite.texture.baseTexture.width
      const spriteHeight = sprite.texture.baseTexture.height

      if (width / height > spriteWidth / spriteHeight) {
        sprite.width = width
        sprite.height = width / (spriteWidth / spriteHeight)
        sprite.y = (((width / (spriteWidth / spriteHeight)) - height) / 2) * -1
        sprite.x = 0
      } else {
        sprite.height = height
        sprite.width = height * (spriteWidth / spriteHeight)
        sprite.x = (((height * (spriteWidth / spriteHeight)) - width) / 2) * -1
        sprite.y = 0
      }
    },

    setTextureSizeContain(sprite, width, height) {
      const spriteWidth = sprite.texture.baseTexture.width
      const spriteHeight = sprite.texture.baseTexture.height
      if (width / height > spriteWidth / spriteHeight) {
        sprite.height = height
        sprite.width = sprite.height * (spriteWidth / spriteHeight)
        if (this.images[sprite.customIndex].alignmiddle === '0') {
          sprite.x = (width - sprite.width) / 2
        } else if (sprite.customIndex % 2 === 0) { // if on the left side
          sprite.x = (width - sprite.width)
        }
        sprite.y = 0
      } else {
        sprite.width = width
        sprite.height = sprite.width * (spriteHeight / spriteWidth)
        sprite.y = (height - sprite.height) / 2
        sprite.x = 0
      }
    },

    setMotionBlur() {
      const deltaPos = (Math.abs((this.leftContainer.y * -1) - this.$refs.scrollWrapper.scrollTop)) / 2
      this.mainContainer.filters[0].velocity.y = deltaPos
    },

    setTextureSizeStretch(sprite, width, height) {
      sprite.width = width
      sprite.height = height
      sprite.x = 0
      sprite.y = 0
    },

    gameLoop() {
      if (this.$route.name === 'Debug') this.stats.begin()

      const scrollTop = this.$refs.scrollWrapper.scrollTop

      this.leftContainer.y = scrollTop * -1
      this.rightContainer.y = scrollTop

      if (this.renderedFrames < 60) {
        this.renderedFrames += 1
      } else {
        this.containers.forEach((container) => {
          const bounds = container.getBounds()
          if (bounds.top < this.screenHeight && bounds.bottom >= 0) {
            container.renderable = true
          } else {
            container.renderable = false
          }
        })
      }

      if (this.$route.name === 'Debug') this.stats.end()
    },

  },
}
</script>

<style scoped lang="scss">
.main-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: background-color 0.3s;
  background-color: #ffff01;

  .images-wrapper {
    display: none;
  }

  .canvas-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .scroll-wrapper {
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    .scroller {
      width: 100%;
      min-height: 100%;
      cursor: auto;

      &.cursor-pointer {
        cursor: pointer;
      }


    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Main.vue